import React, { FC, useCallback } from 'react'
import { BtnComponent, FormNotificationComponent, Heading, i18n, Indent, UITypes } from 'LibNeo'
import { FrontUrls } from 'Constants/FrontUrls'
import { useHistory } from 'react-router-dom'
import { ButtonsWrapper } from './styled'

interface ComponentProps {
	close?: () => void
	orderId?: number
	isDraft?: boolean
}

export const NewOrderModal: FC<ComponentProps> = ({ close, orderId, isDraft }) => {
	const history = useHistory()
	const mainAction = useCallback(() => {
		history.push(FrontUrls.orders_redesign.create)
		close()
	}, [history, close])
	return (
		<>
			<Heading type="h5">{isDraft ? 'Создание заявки' : 'Заявка создана'}</Heading>

			<Indent top={24}>
				<FormNotificationComponent
					type={isDraft ? UITypes.INFO : UITypes.PRIMARY}
					title={isDraft ? `Заявка №${orderId} отправлена в банк` : `Заявка №${orderId} создана!`}
					message={isDraft ? i18n('orders.create_info_draft') : i18n('orders.create_info')}
				/>
			</Indent>

			<Indent top={24}>
				<ButtonsWrapper>
					<Indent right={16}>
						<BtnComponent title="orders.add_new_order" onClick={mainAction} block />
					</Indent>
					{/* <BtnComponent outline title="В список заявок" onClick={close} />*/}
				</ButtonsWrapper>
			</Indent>
		</>
	)
}
